module.exports = __webpack_public_path__ + "static/WhenThePastWasAround0-c535c806eb2b9e3b4795f44fff49b103.png";